import { render } from "./vue-tel-input.vue?vue&type=template&id=0a37fe4c"
import script from "./vue-tel-input.vue?vue&type=script&lang=js"
export * from "./vue-tel-input.vue?vue&type=script&lang=js"

import "../assets/sprite.css?vue&type=style&index=0&lang=css"
import "./vue-tel-input.vue?vue&type=style&index=1&id=0a37fe4c&lang=css"
script.render = render

export default script